/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *请求方法模块
 */

import Vue from 'vue';
import fetch from './fetch.js';
const http = {
  get(url, base, config) {
    for(let i in base) {
      if (!base[i] && base[i] !==0) {
        delete base[i]
      }
    }
    let data = { params: base };
    return fetch(url, data, config);
  },
  post(...arr) {
    return fetch.post(...arr);
  },
  put(url, base, config) {
    let data = base;
    return fetch.put(url, data, config);
  },
  delete(url, base, config) {
    let data = { data: base };
    return fetch.delete(url, data, config);
  }
};
Vue.prototype.$http = http;
export default http;